import React from "react";
import { Col, Row, Typography, Space, Progress } from "antd";
import { CAR_IMAGE_1 } from "assets";

const ExpertNumbersSection = () => {
  return (
    <section className="expert-numbers-section ">
      <div className="container">
        <Row gutter={[20, 30]}>
          <Col
            xs={{ span: 24, order: 2 }}
            md={{ span: 12, order: 1 }}
            className="vertically-centered"
          >
            <Typography.Title className="main-text">
              WE MAKE AUTO REPAIR MORE CONVENIENT
            </Typography.Title>
            <Typography.Paragraph className="sub-text">
              HSTC-Engineering has over 1200 locations across the U.S. and
              Canada to provide armoured and car upgrade services wherever you
              are.
            </Typography.Paragraph>
            <Space direction="vertical">
              <TextWithProgress
                text="HIGHLY QUALIFIED EXPERTS"
                progressPercent={30}
              />
              <TextWithProgress
                text="CLEAN, MODERN FACILITY"
                progressPercent={60}
              />
            </Space>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            md={{ span: 12, order: 2 }}
            className="en-image-wrapper"
          >
            <img src={CAR_IMAGE_1} alt="car" />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ExpertNumbersSection;

const TextWithProgress = ({ text, progressPercent }) => (
  <Space direction="vertical" size={0}>
    <Typography.Text className="m-0">{text}</Typography.Text>
    <Progress steps={16} percent={progressPercent} strokeColor={"#CF6531"} />
  </Space>
);
